/* ============================================================
   ColdCake — global theme JS
   Sticky Ink-dark nav transform, scroll reveals, FAQ accordion fallback
   ============================================================ */

(function () {
  'use strict';

  // ----- Sticky nav: switch to Ink dark on scroll -----
  var navEl = document.querySelector('[data-cc-nav]');
  if (navEl) {
    var threshold = 24;
    var apply = function () {
      if (window.scrollY > threshold) {
        document.body.classList.add('cc-nav-dark');
        navEl.classList.add('cc-nav--scrolled');
      } else {
        document.body.classList.remove('cc-nav-dark');
        navEl.classList.remove('cc-nav--scrolled');
      }
    };
    window.addEventListener('scroll', apply, { passive: true });
    apply();
  }

  // ----- Scroll reveals (IntersectionObserver, with editor + safety fallbacks) -----
  var revealAll = function () {
    document.querySelectorAll('.cc-reveal').forEach(function (el) { el.classList.add('cc-visible'); });
  };
  // 1) Theme editor (Shopify design mode) → reveal immediately, no animation friction
  var inEditor = (window.Shopify && window.Shopify.designMode) ||
                 (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (inEditor) {
    revealAll();
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cc-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.cc-reveal').forEach(function (el) {
      io.observe(el);
      // Reveal anything already in the viewport on first load
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('cc-visible');
      }
    });
    // Safety net: nothing should be hidden 1.2s after load
    setTimeout(revealAll, 1200);
  } else {
    revealAll();
  }

  // ----- FAQ accordion (in case sections forget their own JS) -----
  document.querySelectorAll('.cc-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.cc-faq-item');
      if (!item) return;
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ----- Mobile nav toggle (every [data-cc-mobile-toggle] toggles the panel) -----
  var mobileToggles = document.querySelectorAll('[data-cc-mobile-toggle]');
  var mobilePanel = document.querySelector('[data-cc-mobile-panel]');
  if (mobileToggles.length && mobilePanel) {
    var toggle = function () {
      var open = mobilePanel.classList.toggle('cc-open');
      mobileToggles.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.body.style.overflow = open ? 'hidden' : '';
      };
      mobileToggles.forEach(function (b) { b.addEventListener('click', toggle); });
      document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobilePanel.classList.contains('cc-open')) toggle();
      });
      mobilePanel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
      if (mobilePanel.classList.contains('cc-open')) {
      mobilePanel.classList.remove('cc-open');
      document.body.style.overflow = '';
      }
      });
      });
      }
      })();